<template>
  <div class="hello">

    <div v-if="success">
      <h1 class="is-size-1 has-text-centered">{{ $t('This form has been sent successfully.') }} <i>¡Gracias! </i>
      </h1>
    </div>

    <form v-else @submit.prevent="submit" novalidate>
        <div class="field">
            <label class="label">{{ $t('First name')}}</label>
            <div class="control">
                <input v-model="firstName" type="text" class="input">
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Last name')}}</label>
            <div class="control">
                <input v-model="lastName" type="text" class="input">
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Profession')}}</label>
            <div class="control">
                <input v-model="profession" type="text" class="input">
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('City')}}</label>
            <div class="control">
                <input v-model="city" type="text" class="input">
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Country')}}</label>
            <div class="select is-fullwidth">
                <select v-model="country">
                    <option v-for="country in countries" :value="country.value" :key="country.label">
                    {{ country.label }}
                    </option>
                </select>
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Email (not for publication)')}}</label>
            <div class="control">
                <input v-model="contactEmail" type="email" class="input">
                <div class="has-text-error-message" v-if="v$.contactEmail.$error">{{ $t('email') }}</div>
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Twitter Handle')}}</label>
            <div class="control">
                <input v-model="twitter" type="url" class="input" placeholder="https://">
                <div class="has-text-error-message" v-if="v$.twitter.$error">{{ $t('url') }}</div>
            </div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Instagram Handle')}}</label>
            <div class="control">
                <input v-model="instagram" type="url" class="input" placeholder="https://">
                <div class="has-text-error-message" v-if="v$.instagram.$error">{{ $t('url') }}</div>
            </div>
        </div>

        <label class="label">{{ $t('Please submit a photo of you.')}} <span class="required">*</span></label>
        <div class="uploader uploader2">
            <file-upload v-show="files.length == 0"
                        input-id="file"
                        class="has-text-centered "
                        extensions="jpg,jpeg,png"
                        accept="image/png,image/jpeg"
                        post-action="/api/upload-image/"
                        ref="file1"
                        v-model="files"
                        :headers="{'X-CSRFTOKEN': csrf}"
                        :drop="'.uploader2'"
                        :size="1024 * 1024 *4"
                        @input-filter="inputFilter"
                        @input-file="inputFile"
            >
            <div>
                <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB.')}}
                <br>
                {{ $t('Allowed file types: gif jpg jpeg.')}}
                </div>
            </div>

            </file-upload>
            <div v-if="files.length > 0">
            <div class="columns is-gapless">
                <div class="column is-4">
                <img
                    :src="files.length ? files[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                    class="upload-photo"/>
                </div>
                <div class="column">
                <div>
                    <p class="pb-5">{{ files[0].name }}</p>

                    <button
                        style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                        class="button is-uppercase has-text-weight-bold has-text-white" @click="files=[]"
                        type="button">X
                    </button>
                </div>
                </div>
            </div>
            </div>
            <div class="has-text-error-message" v-if="v$.f1.$error">{{ $t('nec') }}</div>
        </div>

        <div class="field">
            <label class="label">{{ $t('If you were a Sherry wine, what drop would you be and why?') }} <span class="required">*</span></label>
            <div class="control">
            <textarea v-model="whatDrop" class="textarea"></textarea>
            </div>
            <div class="has-text-error-message" v-if="v$.whatDrop.$error">{{ $t('nec') }}</div>
        </div>

        <div class="field">
            <label class="label">{{ $t('What´s your most memorable Sherry moment?') }} <span class="required">*</span></label>
            <div class="control">
            <textarea v-model="memorable" class="textarea"></textarea>
            </div>
            <div class="has-text-error-message" v-if="v$.memorable.$error">{{ $t('nec') }}</div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Where´s your favorite Sherry Spot and why?') }} <span class="required">*</span></label>
            <div class="control">
            <textarea v-model="favouriteSpot" class="textarea"></textarea>
            </div>
            <div class="has-text-error-message" v-if="v$.favouriteSpot.$error">{{ $t('nec') }}</div>
        </div>

        <div class="field">
            <label class="label">{{ $t('Why drink Sherry? ') }} <span class="required">*</span></label>
            <div class="control">
            <textarea v-model="whyDrink" class="textarea"></textarea>
            </div>
            <div class="has-text-error-message" v-if="v$.whyDrink.$error">{{ $t('nec') }}</div>
        </div>

        <div class="field">
            <label class="label">{{ $t('How and where will you be celebrating International Sherry Week?') }} <span class="required">*</span></label>
            <div class="control">
            <textarea v-model="howAndwhere" class="textarea"></textarea>
            </div>
            <div class="has-text-error-message" v-if="v$.howAndwhere.$error">{{ $t('nec') }}</div>
        </div>
        
        <div class="field">
            <input v-model="termsAndConditions" class="is-checkradio" id="termsAndConditionsCheckbox" type="checkbox" name="termsAndConditionsCheckbox"
                checked="checked">
            <label for="termsAndConditionsCheckbox">{{ $t('I accept the conditions laid out in the')}}  <a style="color: #D37700; text-decoration: underline"
                                                        href="https://www.sherry.wine/es/legal">{{ $t('Legal Notice')}}</a>
                                                        {{ $t('AND')}} 
                                                         <a style="color: #D37700; text-decoration: underline"
                                                        href="https://www.sherry.wine/es/legal">{{ $t('Privacy Policy')}}</a>
            <span class="required"> *</span></label>
            <div class="has-text-error-message" v-if="v$.termsAndConditions.$error">{{ $t('nec')}}{{ $t('nec') }}</div>
        </div>

        <div class="pt-5">
            <button style="background: #D37700; font-size: 14px; padding: 20px 40px;border: none"
                    type="submit" class="button is-uppercase has-text-white has-text-weight-bold ">{{ $t('Send')}}
            </button>
        </div>

    </form>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import {required, email, integer, url, helpers, requiredIf} from '@vuelidate/validators';
import VueUploadComponent from 'vue-upload-component';
import axios from "axios";

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

const phone = helpers.regex(/^\+34[0-9 ]{5,10}$/);
//const urlx = helpers.regex(/^http.*$/);

const time = helpers.regex(/^(0?[1-9]|1[012]):[0-5][0-9]$/);

import FileComponent from "./FileComponent.vue";

const hasddress = (value, siblings) => {
  console.log("siblings");
  console.log(siblings);
  return true && value;
};

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export default {

  setup() {
    return {v$: useVuelidate()};
  },
  name: 'Sherrysessoin',
  components: {
    'file-upload': VueUploadComponent,
    'file-component': FileComponent,
  },
  props: {
    csrf: String,
    lang: String,
    waglocale: String
  },
  data() {
      return {
        success: false,

        firstName: '',
        lastName: '',
        profession: '',
        city: '',
        country: null,
        contactEmail: '',
        twitter: '',
        instagram: '',
        whatDrop: '',
        memorable: '',
        favouriteSpot: '',
        whyDrink: '',
        howAndwhere: '',
        files: [],

        f1: null,
        
        termsAndConditions: null,
      }
  },
  validations() {
    function termsAgreed() {
      return this.termsAndConditions
    }
    return {
        f1: {required},
        contactEmail: {email},
        instagram: {url},
        twitter: {url},
        whatDrop: {required},
        memorable: {required},
        favouriteSpot: {required},
        whyDrink: {required},
        howAndwhere: {required},
        termsAndConditions: {required, termsAgreed}

    };
  },
  methods: {
    doSuccess() {
      this.success = true;
      //this.scrollToClass('event')
      window.scrollTo(0, 0);
    },

    async submit() {
        const result = await this.v$.$validate();
        if (!result) {
            // notify user form is invalid
            this.scrollToClass('has-text-error-message');
            return;
        }

        const formData = {
            f1: this.f1,
            firstName: this.firstName,
            lastName: this.lastName,
            profession: this.profession,
            city: this.city,
            country: this.country,
            contactEmail: this.contactEmail,
            twitter: this.twitter,
            instagram: this.instagram,
            whatDrop: this.whatDrop,
            memorable: this.memorable,
            favouriteSpot: this.favouriteSpot,
            whyDrink: this.whyDrink,
            howAndwhere: this.howAndwhere,
            termsAndConditions: this.termsAndConditions,
            waglocale: this.waglocale

        };

        axios.post("/api/sherrysession/", formData)
            .then((res) => {
                console.log(res);
                this.doSuccess();
                // this.success = true;
            })
            .catch((err) => {
                alert("Ha habido un error, contacta con soporte");
            });
    },

    scrollToClass(className) {
      const el = this.$el.getElementsByClassName('has-text-error-message')[0];
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
      }
    },

    async inputFile(newFile, oldFile) {
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
            if (!this.$refs.file1.active) {
            this.$refs.file1.active = true;
            //this.progress(newFile, oldFile)
            }
        }
    },


    inputFilter(newFile, oldFile, prevent) {

      if (newFile && !oldFile) {

        if (!newFile.name.match((/.png|.jpg|.gif$/))) {
          alert("El archivo tiene que ser png o jpg");
          return prevent();
        }
      }

      if (newFile.size > 1024 * 1024 * 4) {
        alert("El archivo tiene que tener menos de 4 MB");
        return prevent();
      }

      if (newFile && newFile.error === "" && newFile.file && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = '';
        let URL = (window.URL || window.webkitURL);
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = '';
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob;
        }
      }
    },

  },
  computed: {
    countries () {
      const list = countries.getNames('en', { select: 'official' })
      return Object.keys(list).map((key) => ({ value: key, label: list[key] }))
    }
  },
  watch: {
      files: {
        handler: function (files, oldVal) {
          if(files.length > 0 && files[0].response && files[0].response.id){
            this.f1 = files[0].response.id
            return
          }
          this.f1 = null

        },
        deep: true
      },
},
  mounted() {
    this.$i18n.locale = this.lang;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.is-checkradio[type=checkbox] + label::after, .is-checkradio[type=checkbox] + label:after {
  color: #292624;
  border-color: #292624;

}

.is-checkradio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before {
  background: #FBF5EF;

}


label.label {
  margin-top: 30px;
}

dio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before, .is-checkradio[type=radio] + label::before, .is-checkradio[type=radio] + label:before {
  border-color: #FBF5EF;
}

.is-checkradio[type=checkbox]:hover:not([disabled]) + label::before, .is-checkradio[type=checkbox]:hover:not([disabled]) + label:before, .is-checkradio[type=radio]:hover:not([disabled]) + label::before, .is-checkradio[type=radio]:hover:not([disabled]) + label:before {
  border-color: #d37700 !important;

}

.uploader {
  padding: 30px;
  background: #FBF5EF;
  border: 1px dashed #C3B193;
  border-radius: 10px;
  width: 100%;
  display: block;

}

.has-text-error-message {
  background: darkred;
  color: white !important;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: 600;
  margin-top: 3px;
  display: block;
}

.upload-photo {
  width: 90%;
  height: auto;
  display: block;

}
</style>